import { useState, useEffect, useRef } from "react";
import { firestore } from "./firebase/firebase";
import { useAuth } from "./firebase/AuthContext";
import { Modal, CircularProgress, Button } from "@mui/material";
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    maxWidth: "70%",
    maxHeight: '90%',
    overflowY: 'scroll',
    overflowX: 'visible'
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
}));

const SendData = ({ selections }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const { currentUser } = useAuth();
  const [subscriptions, setSubscription] = useState(null);
  const classes = useStyles();


    //retrieve the suggestions total from the users firebase doc via stripe

    const getSubscriptions = async () => {
      try {
        const subscriptionsRef = firestore
          .collection("customers")
          .doc(currentUser.uid)
          .collection("subscriptions");
    
        const querySnapshot = await subscriptionsRef.get();
    
        const lastSubscription = querySnapshot.docs.pop();
    
        return [
          {
            id: lastSubscription.id,
            suggestions: lastSubscription.data().items[0].price.product.metadata.Suggestions,
            summaries: lastSubscription.data().items[0].price.product.metadata.Summaries,
            status: lastSubscription.data().status,
            endedAt: lastSubscription.data().ended_at,
          }
        ];
      } catch (error) {
        console.error("Error getting subscriptions: ", error);
        return [];
      }
    };
    
    
    useEffect(() => {
      let isMounted = true;
    
      getSubscriptions().then((subscriptions) => {
        if (isMounted) {
          setSubscription(subscriptions);
        }
      });
    
      return () => {
        isMounted = false;
      };
    }, []);



    const sendSummary = async () => {
      setResponseData([]);
      setLoading(true);
    
      try {
        const response = await axios.post(`${process.env.REACT_APP_PORTAL}/aisummary`, {
          summary: selections,
        });
    
        setResponseData(response.data);
        console.log(response.data);
    
        const subscriptions = await getSubscriptions();
        const currentSubscription = subscriptions[0];
    
        const updatedSummaries = parseInt(currentSubscription.summaries) - 1;
    
        const subscriptionDocRef = firestore
          .collection("customers")
          .doc(currentUser.uid)
          .collection("subscriptions")
          .doc(currentSubscription.id);
    
        await subscriptionDocRef.update({
          "items.0.price.product.metadata": {
            Summaries: updatedSummaries.toString(),
            Suggestions: currentSubscription.suggestions,
            // ... add more fields as needed
          }
        });
    
        console.log("Subscription updated successfully!");
      } catch (error) {
        console.error("Error sending summary:", error);
      } finally {
        setLoading(false);
      }
    };




  const handleOpen = () => {
    setOpen(true);
    sendSummary();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <center>
      {subscriptions === null || subscriptions.length === 0 || subscriptions[0].status === 'canceled' ? null : (
  <Button onClick={handleOpen} style={{ backgroundColor: "#7E3AF2", color: 'white', fontFamily: "Inter", marginLeft: "10px", cursor: 'pointer' }}>
    Generate
  </Button>
)}

      </center>
  
      <Modal
        open={open}
        onClose={handleClose}
        className={classes.modal}
        closeAfterTransition
      >
        <div className={`${classes.paper} ${classes.rounded}`}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '100px', color: '#7E3AF2',overflowY: 'scroll', overflowX: 'visible' }}>
              <CircularProgress style={{color: '#7E3AF2'}}/>
            </div>
          ) : (
            <div>
              {responseData && responseData.choices &&
                responseData.choices.length > 0 && (
                  <h6>{responseData && responseData.choices &&
  responseData.choices.length > 0 && (
    <>{responseData.choices[0].text.split(".").map((i, key) => {
      if (i === ''|| i === null) return null; // add this line
      return <p key={key}>{i}.</p>
    })}</>
  )
}</h6>
                )
              }
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
  
};

export default SendData;
